import { Extension } from "@tiptap/core";

declare module "@tiptap/core" {
  interface Commands<ReturnType> {
    templateExtension: {
      setTemplateId: (templateId: string) => ReturnType;
    };
  }
}

export const TemplateExtension = Extension.create({
  name: "templateExtension",

  addOptions() {
    return {
      templateId: null,
    };
  },

  addGlobalAttributes() {
    return [
      {
        types: ["doc"],
        attributes: {
          templateId: {
            default: this.options.templateId,
            renderHTML: (attributes) => {
              return {
                "data-template-id": attributes.templateId,
              };
            },
            parseHTML: (element) => {
              return {
                templateId: element.getAttribute("data-template-id"),
              };
            },
          },
        },
      },
    ];
  },

  addCommands() {
    return {
      setTemplateId:
        (templateId: string) =>
        ({ state, dispatch }) => {
          state.tr.setDocAttribute("templateId", templateId);
          dispatch?.(state.tr);
          return true;
        },
    };
  },
});
